import { ISuperTableReconcileItem, SuperTableRowType } from '@modeso/types__aumico-lib-annualreport-be';
import { ICellFormat } from '@modeso/types__aumico-lib-core-be';
import { TemplateType } from '@modeso/types__aumico-lib-templates-be';

export interface ISuperTableComponentRowFormValue {
    rowId: string | undefined;
    title: string | null;
    type: SuperTableRowType;
    itemsIds: string[];
    previousValue?: number;
    currentValue?: number;
    format?: ICellFormat;
    reconcileItems?: ISuperTableReconcileItem[] | null;
    reconcilationCurrentYearMismatch?: boolean;
    reconcilationPreviousYearMismatch?: boolean;
    financialType?: TemplateType;
    /** FX (REV-21512): only on RATE rows — the rate itself is never stored. */
    rateSource?: 'closing' | 'average' | 'position';
    [key: string]: string | number | string[] | ICellFormat | ISuperTableReconcileItem[] | boolean; //for extra columns
}
